module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/arrow-down-2867052699cb680210c11d9a3275da8e.svg";